/**
 * Defines different constant values used accross template
 * @module Constants
 */

/**
 * Route values for different pages/menus
 */
export const route = {
    INITIAL: "/",
    home: {
        HOME2: "/index2"
    },
    services: {
        INITIAL: "/services",
        DETAIL: "/detail",
        IT_CONSULTANCY: "/it-consultancy",
        CUSTOM_SOFTWARE: "/custom-software",
        MOBILE_DEVELOPMENT: "/mobile-development",
        PAYMENT_GATEWAY: "/payment-gateway",
        IT_SECURITY: "/it-security"
    },
    pages: {
        INITIAL: "",
        ABOUT: "/about-us",
        CONTACT: "/contact-us",
        CASE_STUDY: "/success-stories",
        PROJECT_DETAIL: "/success-stories/:projectId",
        FAQ: "/faq",
        TEAM: "/our-team",
        PRIVACY_POLICY: "/privacy-policy",
        TERMS_OF_SERVICE: "/terms-of-service",
        COOKIE_POLICY: "/cookie-policy",
        ACCEPTABLE_USE_POLICY: "/acceptable-use-policy",
        DATA_BREACH_POLICY: "/data-breach-policy",
        BUSINESS_CONTINUITY_POLICY: "/business-continuity-policy",
        EMPLOYEE_CODE_OF_CONDUCT: "/employee-code-of-conduct"
    },
    blogs: {
        INITIAL: "/blogs",
        BLOGS: "",
        STANDARD: "/standard",
        LEFT_SIDEBAR: "/with-left-sidebar",
        DETAIL: "/detail",
        BLOG_DETAIL: "/:blogId"
    }
}

/**
 * Global rating measurement value (numarical array)
 */
export const OVERALL_RATING = [1, 2, 3, 4, 5]

/**
 * Values to differentiate theme/visibility
 */
export enum SECTION_THEME { 
    DARK = "dark", 
    LIGHT = "light"
}

/**
 * Values to identify banner section type
 */
export enum BANNER_TYPE { 
    IMAGE = "image", 
    TEXT = "text", 
    CONTACT = "contact",
    COMPACT = "compact"
}

/**
 * Values to identify box type for blog list
 */
export enum BLOG_BOX { 
    IMAGE = "image", 
    VIDEO = "video", 
    AUDIO = "audio" 
}

/**
 * CSS manipulation for non clickable anchors
 */
export const stopAnchorNavigation: React.CSSProperties = {
    pointerEvents: "none",
    cursor: "default"
}